import {all} from 'redux-saga/effects'

export default function * rootSaga (getState) {
  yield all([])
}



// WEBPACK FOOTER //
// ./sagas/index.js